// Brand constants. Logo asset uploaded by user.
export const BRAND_NAME = "HouseEntry Solutions";
export const BRAND_TAGLINE = "Exclusive listings. Verified deals. Smarter choices.";
export const BRAND_SHORT = "HouseEntry";
export const SUPPORT_EMAIL = "houseentrysolutions@gmail.com";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_prop-intel-7/artifacts/6ylkg7da_houseentry_logo_-removebg-preview-removebg-preview.png";

// v2.71.101 — Unit-aware size formatter (sqft/sqyd/sqm/acre).
const UNIT_LABEL = { sqft: "Sq Ft", sqyd: "Sq Yd", sqm: "Sq M", acre: "Acre" };
const sizeLabel = (n, u) => {
  if (!n && n !== 0) return "";
  const v = Math.round(Number(n));
  if (!v) return "";
  const lbl = UNIT_LABEL[String(u || "sqyd").toLowerCase()] || UNIT_LABEL.sqyd;
  return `${v} ${lbl}`;
};

// WhatsApp share helper
// v2.71.101 — Rewritten so the share message dynamically reflects the listing.
// • Sale  → shows asking price + booking amount / negotiable flag if available.
// • Rent  → shows monthly_rent and deposit (NOT sale price).
// • Lease → shows monthly_rent + lease duration months.
// Always includes: Property Type, Listing Intent, Location (main+sub area),
// Size in the saved unit, Property ID (short), and the brand footer.
export const buildPropertyShareText = (p, link) => {
  const formatINR = (n) => {
    if (!n && n !== 0) return "";
    const num = Number(n);
    if (!num) return "";
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
    return `₹${num.toLocaleString("en-IN")}`;
  };
  const formatDist = (m) => {
    if (!m && m !== 0) return "";
    return m < 1000 ? `${m}m` : `${(m / 1000).toFixed(1)}km`;
  };
  const intent = (p.listing_intent || "sale").toLowerCase();
  const intentBadge = intent === "rent" ? "FOR RENT" : intent === "lease" ? "FOR LEASE" : "FOR SALE";
  const locParts = [p.sub_area, p.main_area || p.area].filter(Boolean);
  const sizeText = sizeLabel(p.size_sqft, p.size_unit);
  const idShort = p.id ? String(p.id).slice(0, 8).toUpperCase() : "";

  const lines = [];
  lines.push(`🏠 *${p.title || "Untitled Listing"}*`);
  lines.push(`🏷️ ${intentBadge}  •  ${p.property_type || "Property"}${p.bhk && p.bhk !== "Not Specified" ? "  •  " + p.bhk : ""}`);
  if (locParts.length) lines.push(`📍 ${locParts.join(", ")}`);
  if (sizeText) lines.push(`📐 ${sizeText}${p.furnishing && p.furnishing !== "Unfurnished" ? "  •  " + p.furnishing : ""}`);

  // Price block — intent aware.
  if (intent === "rent") {
    const rent = formatINR(p.monthly_rent || p.rent_details?.monthly_rent);
    if (rent) lines.push(`💰 ${rent}/month`);
    const dep = formatINR(p.rent_details?.security_deposit);
    if (dep) lines.push(`🔒 Deposit: ${dep}`);
  } else if (intent === "lease") {
    const rent = formatINR(p.monthly_rent);
    if (rent) lines.push(`💰 ${rent}/month (Lease)`);
    if (p.lease_details?.lease_duration_months) lines.push(`📅 Duration: ${p.lease_details.lease_duration_months} months`);
  } else {
    const price = formatINR(p.price);
    if (price) lines.push(`💰 ${price}` + (p.roi ? `  •  ROI ${Number(p.roi).toFixed(1)}%` : ""));
    if (p.sale_details?.negotiable) lines.push(`🤝 Negotiable`);
  }

  if (p.distance_metro_m) lines.push(`🚇 ${formatDist(p.distance_metro_m)} from metro`);
  if (idShort) lines.push(`🔖 ID: ${idShort}`);
  if (link) lines.push(`🔗 ${link}`);
  lines.push(`— ${BRAND_NAME}`);
  return lines.join("\n");
};

export const buildShortlistShareText = (shortlist, propertyCount, link) => {
  return [
    `🏘️ *${shortlist.name}*` + (shortlist.client_name ? ` for ${shortlist.client_name}` : ""),
    `${propertyCount} curated properties — view full details:`,
    link,
    `— ${BRAND_NAME}`,
  ].join("\n");
};

export const whatsappLink = (text) =>
  `https://wa.me/?text=${encodeURIComponent(text)}`;
